import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VBtn,{class:[
    'app-button',
    _vm.size,
    `bg-${_vm.background}`,
    `color-${_vm.color}`,
    `circle-color-${_vm.circleColor}
    ${_vm.disabled ? 'disabled' : ''}`,
  ],attrs:{"disabled":_vm.disabled}},[_c('div',{staticClass:"bg"}),_c('span',{staticClass:"text",class:!_vm.icon ? 'text-center' : ''},[_vm._v(_vm._s(_vm.text))]),(_vm.icon)?_c('div',{staticClass:"circle"},[(!_vm.loading)?_c(VIcon,[_vm._v(_vm._s(_vm.icon))]):_c(VIcon,{staticClass:"mdi-spin"},[_vm._v("mdi-loading")])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }